module.exports = __webpack_public_path__ + "img/logo_2022_inverted.a1bd8784.png";